export class Brand {
  brandId: string;
  name: string;

  constructor(params?: BrandParams) {
    this.brandId = params?.brandId;
    this.name = params?.name;
  }
}

export interface BrandParams {
  brandId?: string;
  name?: string;
}
